// extracted by mini-css-extract-plugin
export default {"section":"Contact_section__VMJsU","shell":"Contact_shell__X1AhB","infoColumn":"Contact_infoColumn__mN861","infoItem":"Contact_infoItem__kK6Jh","infoIcon":"Contact_infoIcon__CFlHK"};